import { render, staticRenderFns } from "./emergency_treatment.vue?vue&type=template&id=9518007c&scoped=true"
import script from "./emergency_treatment.vue?vue&type=script&lang=js"
export * from "./emergency_treatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9518007c",
  null
  
)

export default component.exports